import Vue from 'vue';

Vue.component('pc-layout', () => import('./PCLayout'));